export default __webpack_public_path__ + "static/media/filter.1d1e8094.svg";